module.exports = __webpack_public_path__ + "static/feature_abonements-8bc8e7dc3cf6a34e1779af1ec8911c90.png";